import { Component, OnInit, Output, Input, EventEmitter, SimpleChanges, ChangeDetectionStrategy, ChangeDetectorRef, TemplateRef, ElementRef } from '@angular/core';
import { GlobalService } from '../services/global.service';
import { DatePipe, CurrencyPipe, DecimalPipe } from '@angular/common';
import { HoursPipe } from '../pipes/hours.pipe';
import { MinutesPipe } from '../pipes/minutes.pipe';
import { CASH_ADVANCE_STATUS, INVOICE_STATUS } from '../conf/cash_advance';
import { PaginationOptions } from '../conf/pagination-options.interface';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { PageCountPipe } from '../pipes/page-count.pipe';

@Component({
    selector: 'app-table',
    templateUrl: './table.component.html',
    styleUrls: ['./table.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TableComponent implements OnInit {
	@Input() headers: any;
	@Input() list: any;
	@Input() pagination: boolean;
	@Input() addCheck: boolean;
	@Input() orderBy: any = []
	@Input() full: boolean;
	@Input() noGap: boolean;
	@Input() noMargin: boolean;
	@Input() height100: boolean;
	@Input() maxHeight: string;
	@Input() canOrder: boolean = true;
	@Input() paginationOptions: PaginationOptions;
	@Input() backendPaginationOptions: PaginationOptions;
	@Input() showMobileMenu: boolean = false;
	@Input() showFilterMenu?: boolean = false;
	@Input() filterTemplate: TemplateRef<any>;
	@Input() trackBy: boolean = false;
	@Input() trackById: string = 'id';
	@Input() newStyle: boolean = false;
	@Input() detailStyle: boolean = false;
	@Input() progressHead: boolean = false;
	@Input() transit: boolean = false;
	@Input() relativePagination: boolean = false;
	@Input() w100: boolean = false;
	@Input() caption: boolean = false;
	@Input() captionData: any = null;
	@Input() showClearButton: boolean = true;
	@Input() marBottom: any = null;
	@Input() currentProject?: any;
	@Input() footerValues: any = null;
	@Input() activateDragAndDrop?: boolean = false;

	@Output() ClickComment = new EventEmitter<any>();
	@Output() userClick = new EventEmitter<any>();
	@Output() contextClick = new EventEmitter<string>();
	@Output() dblClick = new EventEmitter<string>();
	@Output() oneClick = new EventEmitter<string>();
	@Output() notifyOrderTable: EventEmitter<any> = new EventEmitter<any>();
	@Output() onChangePagination = new EventEmitter<number>();
	@Output() onFilterClick = new EventEmitter<any>();
	@Output() onClearFilters = new EventEmitter<any>();
	@Output() onChangeBulkScene = new EventEmitter<any>();
	@Output() onSendOptionId = new EventEmitter<any>();
	@Output() actionCaption = new EventEmitter<any>();
	@Output() actionIconTr = new EventEmitter<any>();
	@Output() onSearchText = new EventEmitter<any>();
	@Output() restartList = new EventEmitter<any>();
	@Output() onEditField = new EventEmitter<any>();

	sliceSize: number = 30;
	sliceStart: number = 0;

	printSliceSize: number = 30;
	printSliceStart: number = 0;

	checked_all: boolean = false;
	headersShow: any;
	lastClickedWasFilter: boolean = false;
	hideContent: boolean = false;
	changeColorOption: boolean = false;
	textSearch: string = '';
	searchTextInTable: boolean = false;
	view: string = 'home';
	dataToEdit: any = null;
	itemEdit: any = null;

	drop(event: CdkDragDrop<string[]>) {
		moveItemInArray(this.list, event.previousIndex, event.currentIndex);
	}

	check_list() {
		for (let itm of this.list) {
			if (this.checked_all) {
				itm.checked = true;
				this.changeBulk(itm);
			} else {
				itm.checked = false;
				this.changeBulk(itm);
			}
		}
	}
	changeBulk(item) {
		this.onChangeBulkScene.emit(item);
	}
	dblclick(event, scn) {
		const payload: any = { 'event': event, 'scn': scn }
		this.dblClick.emit(payload)

	}
	click(event, scn) {
		const payload: any = { 'event': event, 'scn': scn }
		this.oneClick.emit(payload)
	}

	clearFilters() {
		this.onClearFilters.emit();
	}

	selectRow(ev) {
		this.contextClick.emit(ev)
	}
	ordertable(head) {
		let fieldOrder = head.type == 'back_translate' ? head.value + '_' + this._gS.getLenguage() : head.value;
		if (!this.lastClickedWasFilter) {
			this.notifyOrderTable.emit(head.orderData || fieldOrder);
		}
		this.lastClickedWasFilter = false;
	}

	changePagPosition(ev, emit = true) {

		if (this.backendPaginationOptions) {
			this.setPagination()

			if (ev == 'next') {
				this.printSliceStart = this.printSliceStart + this.printSliceSize
			} else if (ev == 'previous') {
				this.printSliceStart = this.printSliceStart - this.printSliceSize
			} else if (ev == 'first') {
				this.printSliceStart = 0
			} else if (ev == 'last') {
				this.printSliceStart = Math.floor(this.list.length / this.printSliceSize) * this.printSliceSize
			}

			if (emit) {
				this.onChangePagination.emit(this.printSliceStart);
			}

			return;
		}

		if (ev == 'next') {
			this.sliceStart = this.sliceStart + this.sliceSize
			this.printSliceStart = this.printSliceStart + this.printSliceSize
		} else if (ev == 'previous') {
			this.sliceStart = this.sliceStart - this.sliceSize
			this.printSliceStart = this.printSliceStart - this.printSliceSize
		} else if (ev == 'first') {
			this.sliceStart = 0
			this.printSliceStart = 0
		} else if (ev == 'last') {
			this.sliceStart = Math.floor(this.list.length / this.sliceSize) * this.sliceSize
			this.printSliceStart = Math.floor(this.list.length / this.printSliceSize) * this.printSliceSize
		}
		if (emit) {
			this.onChangePagination.emit(this.sliceStart);
		}
	}

	checkClass(scn, head) {
		let a = ''
		if (head.sticky) {
			a += 'sticky-left'
		}

		if (head.sceneClass) {

			if (scn.scene_status_id == 1) {
				a += ' pre-breakdown'
			} else if (scn.scene_status_id == 2) {
				a += ' private'
			} else if (scn.scene_status_id == 3) {
				a += ' not-assigned'
			} else if (scn.scene_status_id == 4) {
				a += ' assigned'
			} else if (scn.scene_status_id == 5) {
				a += ' produced'
			} else if (scn.scene_status_id == 8) {
				a += ' cancel'
			}
			if (scn.scene_type_id == 2) {
				a += ' protection'
			}
		}
		if (head.clipClass) {
			if (scn.sc_clip_status_id == 1) {
				a += ' new_clip'
			} else if (scn.sc_clip_status_id == 2) {
				a += ' ingested_clip'
			} else if (scn.sc_clip_status_id == 3) {
				a += ' sync_clip'
			} else if (scn.sc_clip_status_id == 4) {
				a += ' not_found_clip'
			}
		}
		if (head.cashClass) {
			if (scn.ca_ad_status_id == CASH_ADVANCE_STATUS.Requested) {
				a += ' new'
			} else if (scn.ca_ad_status_id == CASH_ADVANCE_STATUS.OnApproval) {
				a += ' on_approval'
			} else if (scn.ca_ad_status_id == CASH_ADVANCE_STATUS.Approved) {
				a += ' approved'
			} else if (scn.ca_ad_status_id == CASH_ADVANCE_STATUS.Rejected) {
				a += ' rejected'
			} else if (scn.ca_ad_status_id == CASH_ADVANCE_STATUS.Submitted) {
				a += ' submited'
			} else if (scn.ca_ad_status_id == CASH_ADVANCE_STATUS.Legalized) {
				a += ' legalized'
			}
		}
		if (head.invClass) {
			if (scn.invoice_status_id == INVOICE_STATUS.New) {
				a += ' new'
			} else if (scn.invoice_status_id == INVOICE_STATUS.Submitted) {
				a += ' submited'
			} else if (scn.invoice_status_id == INVOICE_STATUS.Rejected) {
				a += ' rejected'
			} else if (scn.invoice_status_id == INVOICE_STATUS.Legalized) {
				a += ' legalized'
			} else if (scn.invoice_status_id == INVOICE_STATUS.Approved) {
				a += ' approved'
			} else if (scn.invoice_status_id == INVOICE_STATUS.ReviewedFinances) {
				a += ' review'
			}
		}
		if (head.shootClass) {
			if (scn.shooting_shedule_status_id == 1) {
				a += ' not-assigned'
			} else if (scn.shooting_shedule_status_id == 2) {
				a += ' assigned'
			} else if (scn.shooting_shedule_status_id == 3) {
				a += ' submited'
			} else if (scn.shooting_shedule_status_id == 4) {
				a += ' produced'
			} else if (scn.shooting_shedule_status_id == 5) {
				a += ' cancel'
			} else if (scn.shooting_shedule_status_id == 6) {
				a += ' private'
			}
		}
		if (head.clipSelectedClass) {
			if (scn.selected_clip) {
				a += ' selected-clip'
			}
		}
		if (head.assetClass) {

			if (scn.task_statuses_id == 1) {
				a += ' not-started'
			} else if (scn.task_statuses_id == 2) {
				a += ' pending'
			} else if (scn.task_statuses_id == 3) {
				a += ' on-transit'
			} else if (scn.task_statuses_id == 4) {
				a += ' completed'
			} else if (scn.task_statuses_id == 5) {
				a += ' rejected'
			}
		}

		if (head.breakdownClass) {

			if (scn.breakdown_scene == 1) {
				a += ' character'
			} else if (scn.breakdown_scene == 2) {
				a += ' element'
			} else if (scn.breakdown_scene == 3) {
				a += ' event'
			}
		}
		return a
	}
	getValue(scn, head, number?) {
		if (head.type == 'back_translate') {
			let value = scn[head.value + '_' + this._gS.getLenguage()];
			return value || value == 0 ? value : '--'
		} else if (head.type == 'list' || head.type == 'list_back_translate') {
				if (number) {
					return scn[head.value]
				} else {
					if (head.type == 'list_back_translate') {
						const a = scn[head.list + '_' + this._gS.getLenguage()]
						return a ? a : '--'
					} else {
						const a = scn[head.list]
						return a ? a : '--'
					}
				}
			} else if (head.type == 'Minutes') {
				if (!scn[head.value]) {
					return '--:--'
				}
				const minutes = Math.floor(scn[head.value] / 60);
				const seconds = scn[head.value] - minutes * 60;
				let retval = minutes.toString() + ":" + seconds.toString()
			if (seconds < 10) {
				retval = minutes.toString() + ":0" + seconds.toString()
			}
			return retval
		} else if (head.type == 'hours') {
			if (!scn[head.value]) {
				return '--:--'
			}
			return this.hoursPipe.transform(Number(scn[head.value]));

		} else if (head.type == 'pages') {
			if(!scn[head.value]) {
				return '--'
			}
			return this.pagesPipe.transform(Number(scn[head.value]), true);
		}
		
		else if (head.type == 'minutes-pipe') {
			if (!scn[head.value]) {
				return '--:--'
			}
			return this.minutesPipe.transform(Number(scn[head.value]));

			} else if (head.type == 'number') {
				const a = scn[head.value]
				return a ? a : 0;
			} else if (head.type == 'percent') {
				const a = scn[head.value]
				return a ? parseFloat(a).toFixed(2) + '%' : '0%';
		} else if (head.type == 'date') {
			if (!scn[head.value]) {
				return '--/--/----'
			}
			return this._datePipe.transform(scn[head.value], 'MMM-dd-yyyy')

		} else if (head.type == 'dateDay') {
			if (!scn[head.value]) {
				return '--/--/----'
			}
			return this._datePipe.transform(scn[head.value], 'EEEE')

		} else if (head.type == 'time') {
			if (!scn[head.value]) {
				return '--:-- --'
			}
			let time = scn[head.value];
			return this._datePipe.transform(this._gS.getStaticDateHour(time), 'h:mm a')
		} else if (head.type == 'currency') {
			let value = scn[head.value];
			return value || value == 0 ? this._currencyPipe.transform(value, '$') : '--';

		} else if (head.type == 'date_time') {
			if (!scn[head.value]) {
				return '--:-- --'
			}
			let date_time = scn[head.value];
			return this._datePipe.transform(this._gS.getStaticDateHour(date_time), 'MMM-dd-yyyy h:mm a')
		} else if (head.type == 'ok_field') {
			let value = scn[head.value];
			return value ? 'OK' : '--'
		} else if (head.type == 'link') {
			let value = scn[head.value];
			return value || value == 0 ? value : ''
			} else if (!head.type) {
				const a = scn[head.value]
				return a ? a : '--'
			}
		else if (head.type == 'progress_bar') {
			let value = scn[head.value];
			return value || value == 0 ? value : ''
		}
		else if (head.type == 'title_subtitle') {
			let array = [];
			array.push(scn[head.value]);
			array.push(scn[head.sub_value + '_' + this._gS.getLenguage()]);
			return array
		}
			else if (head.type == 'options') {
				const value = (scn[head.value]);
				if (value == '' || value == undefined || value == null) {
					this.changeColorOption = false;
					return 'DELIVER';
			}
			else {
				if (head.multipleOptions != undefined) {
					this.changeColorOption = true;
					head.multipleOptions.forEach((option, index) => {
						option.disabled = false;
						if (option.id == 1) 
							option.color = '#34D046';
						else if (option.id == 2)
							option.color = '#ED1818';
					});

					let value = scn[head.status];
					if (value == 2 || value == 3) {
						head.multipleOptions.forEach((option, index) => {
							if (option.id == 1 || option.id == 2) {
								option.disabled = true;
								option.color = '#C5C6C5';
							}
						});
					}
					return 'multiple'
				}
				else {
					return '';
				}
			}
		}
	}

	sendOptionId(event, item, head, option?) {
		const obj: Object = option != undefined && option != null
			? {
				item: item,
				typeRepository: head.typeRepository,
				option: option
			}
			: {
				typeRepository: head.typeRepository,
				item: item,
				option: null 
			};
		this.onSendOptionId.emit(obj);
	}

	filterTable(event, field) {
		this.lastClickedWasFilter = true;
		this.contextClick.emit(null)
		this.onFilterClick.emit(field);
		this.showFilterMenu = true;
		this._gS.openContextMenu(event);
	}

	InfoUserHover($event) {
		this._gS.rigthClick($event, 3, { 'left': 15, 'top': 0 });
		this._gS.hidemenu();
	}

	setPagination() {


		if (this.backendPaginationOptions) {
			this.sliceSize = this.backendPaginationOptions.sliceSize;
			this.sliceStart = this.backendPaginationOptions.sliceStart;

			this.printSliceSize = this.paginationOptions.sliceSize;
			this.printSliceStart = this.paginationOptions.sliceStart;
		} else {
			this.sliceSize = this.paginationOptions.sliceSize;
			this.sliceStart = this.paginationOptions.sliceStart;

			this.printSliceSize = this.paginationOptions.sliceSize;
			this.printSliceStart = this.paginationOptions.sliceStart;
		}

	}

	onClickUser(event, row, unique = false) {
		const firstRow = unique ? { ...row, showOnly: unique } : row
		this.userClick.emit({ event, row: firstRow })
	}

	onClickComment(event, row) {
		this.ClickComment.emit({ event, row })
	}

	checkColorClass(scn, head) {
		if (this.transit) {
			if (scn.transit_asset_status == 2)
				return 'color-approve';
			else if (scn.transit_asset_status == 3)
				return 'color-reject';
			else
				return 'color-normal';
		}
		else {
			if (scn.client_asset_status == 2)
				return 'color-approve';
			else if (scn.client_asset_status == 3)
				return 'color-reject';
			else
				return 'color-normal';
		}
	}

	actionIconCaption(ev) {
		ev.stopPropagation();
		this.actionCaption.emit();
	}

	checkColorIcon(scn, head) {
		if (scn[head.isActive]) return 'show-color';
	}

	onIconTr(item) {
		this.actionIconTr.emit(item);
	}

	actionSearchText() {
		this.onSearchText.emit(this.textSearch);
	}

	restartData() {
		this.textSearch = '';
		this.restartList.emit();
	}

	editField(item, head) {
		this.itemEdit = item;
		this.dataToEdit = this._gS.setPopupEditData(item[head.value], head.name, head.value, head.formType, head.inputType);
		if (head?.showCheck) {
			this.dataToEdit['showCheck'] = head.showCheck;
			this.dataToEdit['textCheck'] = head.textCheck;
			this.dataToEdit['valueCheck'] = item[head.valueCheck];
			this.dataToEdit['var_name_check'] = head.valueCheck;
		}
		this.changeView('edit-popup');
	}

	editData(ev) {
		this.itemEdit[ev.var_name] = ev.value;
		if (ev.valueCheck) this.itemEdit[ev.var_name_check] = ev.valueCheck;
		this.view = 'home';
		this.onEditField.emit(this.itemEdit);
	}

	changeView(ev) {
		this.view = ev;
	}

	constructor(
		public _gS: GlobalService,
		private _datePipe: DatePipe,
		private _currencyPipe: CurrencyPipe,
		private hoursPipe: HoursPipe,
		private minutesPipe: MinutesPipe,
		private pagesPipe: PageCountPipe,
		private _cD: ChangeDetectorRef) {}

	ngOnInit() {
		if (this.backendPaginationOptions) {
			this.setPagination()
		}
		this.headersShow = this.headers.filter(head => head.visible != false)
	}
	ngOnChanges(changes: SimpleChanges) {
		if (!this.pagination) {
			this.sliceSize = this.list.length
			this.printSliceSize = this.list.length
		}
		if (changes.list && !changes.firstChange) {
			this.changePagPosition('first', false)

		}
		if ((changes.paginationOptions || changes.list) && this.paginationOptions) {
			let sum = this.paginationOptions.sliceStart + this.paginationOptions.sliceSize;

			if (!this.backendPaginationOptions) {
				let slicedList = this.list.slice(this.paginationOptions.sliceStart, sum);
				if (slicedList.length) {
					this.setPagination()
				} else {
					this.changePagPosition('first')
				}
			}
		}
		this.headersShow = this.headers.filter(head => head.visible != false);
		if (!this.addCheck) this.checked_all = false;

		if (this.backendPaginationOptions) {
			this.setPagination()
		}
	}

}
